import {
	Divider,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { useAuth } from '../../../hooks/auth';

type SortData = {
  por: string;
  cres: boolean;
};
type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type VendaData = {
	agendamento: boolean;
	campanha: string;
	cupom: { id_desconto: string; type_desc: string; valor: string };
	distance: number;
	duration: number;
	endereco_entrega: EnderecoData;
	formatted_address: string;
	hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
	id_order: number;
	items: ItemData[];
	merchant_id: number;
	mesa: boolean;
	mesa_number: string;
	mesa_token: string;
	order_data: string;
	order_status: string;
	pagamentos: PagamentoData[];
	prev_entrega: string;
	retirar: boolean;
	subTotal: number;
	taxa_entrega: number;
	taxa_service: number;
	tempo_preparo: number;
	tempo_preparo_str: string;
	total: number;
	totalFormatted: string;
	total_merchant: number;
}
type EnderecoData = {
	bai: string;
	cep: string;
	cid: string;
	cidcod: string;
	comp: string;
	distace: {
		distance: { value: number };
		duration: { value: number };
	};
	endereco: string;
	formatted_address: string;
	id: string;
	location: { lat: number; lng: number };
	num: string;
	ponto_ref: string;
	uf: string;
}
type PagamentoData = {
	band_pay: string;
	chave_pay: string;
	currency_pay: string;
	id_pay: number;
	method_pay: string;
	name_pay: string;
	tipchave_pay: string;
	trocoFormatted: string;
	troco_para: number;
	type_pay: string;
	url_pay: string;
}
type ItemData = {
	cod_barras: string;
	complementos: ComplementoData[];
	descricao: string;
	id: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	totalFormatted: string;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
}
type ComplementoData = {
	codigo: string;
	descricao: string;
	grupo: string;
	nome: string;
	priceFormatted: string;
	qtd: number;
	qtd_gratis: number;
	qtd_maxima: number;
	valor: number;
}
interface DataTableTableParams {
  vendas: VendaData[];
  pesqVendas: VendaData[];
  sort: SortData;
  setSort: (sort: SortData) => void;
  controls: ControlsData;
  handleUpdateList: (
    page: number,
    perPage: number,
    vendas: VendaData[],
  ) => void;
	setVendaModal: (vendas: VendaData) => void;
	setModalVendaVisible: (visible: boolean) => void;
	setModalVendaCancelarVisible: (visible: boolean) => void;
}

const DataTableTable: React.FC<DataTableTableParams> = ({
	vendas,
	pesqVendas,
  sort,
  setSort,
  controls,
  handleUpdateList,
	setVendaModal,
	setModalVendaVisible,
	setModalVendaCancelarVisible
}) => {
	const { permissions } = useAuth();

  function handleSort(prop: string) {
		let mapped: VendaData[] = [];

    const auxCres = !sort.cres;

    if (sort.por === prop) {
      if (auxCres) {
        mapped = pesqVendas.sort((a, b) => {
          return (
            +(Object(a)[prop] > Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      } else {
        mapped = pesqVendas.sort((a, b) => {
          return (
            +(Object(a)[prop] < Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      }
      setSort({ ...sort, cres: auxCres });
    } else {
      mapped = pesqVendas.sort((a, b) => {
        return (
          +(Object(a)[prop] > Object(b)[prop]) ||
          +(Object(a)[prop] === Object(b)[prop]) - 1
        );
      });
      setSort({ por: prop, cres: true });
    }

    // setSort({ por: prop, cres: !sort.cres });

    handleUpdateList(1, controls.perPage, mapped);
  }

  return (
		<Table 
			variant="striped"
			colorScheme="blackAlpha"
			size="sm"
			w="100%"
		>
      <Thead>
        <Tr>
          <Th cursor="pointer" onClick={() => handleSort('order_status')}>
            <Flex>
              STATUS
              {sort.por === 'order_status' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'order_status' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

          <Th cursor="pointer" onClick={() => handleSort('name_cliente')}>
            <Flex>
              CLIENTE
              {sort.por === 'name_cliente' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'name_cliente' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

          <Th cursor="pointer" onClick={() => handleSort('id_order')}>
            <Flex justifyContent="flex-end">
              ID PEDIDO
              {sort.por === 'id_order' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'id_order' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer">
						<Flex justifyContent="flex-end">
							ITEMS
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('order_data')}>
						<Flex justifyContent="flex-end">
							DATA CRIAÇÃO
							{sort.por === 'order_data' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize={20} />
							) : (
								sort.por === 'order_data' &&
									!sort.cres && <Icon as={MdArrowDropDown} fontSize={20} />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('totalFormatted')}>
						<Flex justifyContent="flex-end">
							VLR. TOTAL
							{sort.por === 'totalFormatted' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'totalFormatted' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th></Th>
        </Tr>
      </Thead>

      <Tbody>
				{vendas.map(venda => {
          return (
						<Tr key={venda.id_order} color="gray.700" fontSize={14}>
              <Td cursor="pointer">
								<Text
									textTransform="uppercase"
									color={venda.order_status === 'CANCELADO'
										? '#b71c1c'
										: venda.order_status === 'CONCLUÍDO' || venda.order_status === 'CONFIRMADA' || venda.order_status === 'FINALIZADA' 
											? '#1b5e20'
											: venda.order_status === 'COM ENTREGADOR' || venda.order_status === 'EM PREPARO'
												? '#1a83ff'
												: '#ff6f00'
									}
									fontWeight="bold"
								>
									{venda.order_status}
								</Text>
              </Td>

							<Td>
								{venda.cliente?.nome}
              </Td>

							<Td isNumeric>
								{venda.id_order}
              </Td>

							<Td isNumeric>
								{venda.items.length}
							</Td>

							<Td isNumeric>
								{venda.order_data}
							</Td>

							<Td isNumeric>
								{venda.totalFormatted}
							</Td>

							<Td>
								<Menu>
									{({ isOpen }) => (
										<>
											<MenuButton
												border={0}
												fontSize="1.5626rem"
												as={IconButton}
												isActive={isOpen}
												aria-label="Options"
												icon={<FiMoreVertical />}
												variant="outline"
												_hover={{
													bg: 'gray.50'
												}}
											/>

											<MenuList p={0} boxShadow='xl'>
												<MenuItem
													fontSize={16}
													fontWeight={500}
													py={3}
													_hover={{
														bg: 'gray.50'
													}}
													onClick={() => {
														setVendaModal(venda);
														setModalVendaVisible(true);
													}}
												>
													Detalhes
												</MenuItem>

												{permissions.excluir && (
													<>
														<Divider />

														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{
																bg: 'gray.50'
															}}
															onClick={() => {
																setVendaModal(venda);
																setModalVendaCancelarVisible(true);
															}}
															isDisabled={
																venda.order_status &&
																	venda.order_status.toUpperCase() === 'CANCELADO'
																	? true
																	: false
															}
														>
															Cancelar
														</MenuItem>
													</>
												)}
											</MenuList>
										</>
									)}
								</Menu>
							</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default DataTableTable;
